// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sashe-orders-page {
  padding: 1.5rem;
  max-width: 1500px;
  margin: 0 auto;
  color: var(--text-primary, #e2e8f0);
}

.sashe-orders-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sashe-orders-header h1 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.6rem;
  color: var(--text-primary, #e2e8f0);
}

.last-sync {
  font-size: 0.8rem;
  color: rgba(226, 232, 240, 0.5);
}

.btn-sync {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 1.3rem;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.4), rgba(139, 92, 246, 0.4));
  border: 1px solid rgba(99, 102, 241, 0.4);
  color: white;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-sync:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.55), rgba(139, 92, 246, 0.55));
}

.btn-sync:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Stats cards */
.stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1.5fr;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 1024px) {
  .stats-grid { grid-template-columns: 1fr; }
}

.stat-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  border-radius: 14px;
  padding: 1.25rem 1.4rem;
  transition: all 0.2s;
}

.stat-card.week {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(99, 102, 241, 0.08));
  border-color: rgba(99, 102, 241, 0.25);
}

.stat-card.month {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.12), rgba(34, 197, 94, 0.08));
  border-color: rgba(16, 185, 129, 0.25);
}

.stat-card.status {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.1), rgba(168, 85, 247, 0.06));
  border-color: rgba(139, 92, 246, 0.25);
}

.stat-label {
  font-size: 0.75rem;
  color: rgba(226, 232, 240, 0.55);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 600;
  margin-bottom: 8px;
}

.stat-main {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary, #f1f5f9);
  margin-bottom: 10px;
  line-height: 1;
}

.stat-sub {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.85rem;
  color: rgba(226, 232, 240, 0.7);
}

.stat-sub strong {
  color: #fbbf24;
  font-weight: 600;
}

.status-mini-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 180px;
  overflow-y: auto;
}

.status-mini-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 0.85rem;
}

.status-mini-item .mini-label {
  flex: 1 1;
  color: rgba(226, 232, 240, 0.8);
}

.status-mini-item .mini-count {
  font-weight: 600;
  color: var(--text-primary, #f1f5f9);
  background: rgba(255, 255, 255, 0.08);
  padding: 1px 8px;
  border-radius: 8px;
  font-size: 0.8rem;
}

/* Filters */
.filters-row {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 1rem 1.2rem;
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.filter-group > label {
  font-size: 0.8rem;
  color: rgba(226, 232, 240, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  min-width: 60px;
}

.eshop-tabs {
  display: flex;
  gap: 4px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 4px;
}

.eshop-tab {
  background: transparent;
  border: none;
  color: rgba(226, 232, 240, 0.65);
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.15s;
}

.eshop-tab:hover {
  color: var(--text-primary, #e2e8f0);
}

.eshop-tab.active {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.4), rgba(139, 92, 246, 0.4));
  color: white;
}

.status-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  cursor: pointer;
  font-size: 0.8rem;
  color: rgba(226, 232, 240, 0.7);
  transition: all 0.15s;
}

.status-chip:hover {
  background: rgba(255, 255, 255, 0.08);
}

.status-chip.clear {
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
  border-color: rgba(239, 68, 68, 0.3);
}

/* Orders table */
.orders-table-wrapper {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  overflow: hidden;
  overflow-x: auto;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
}

.orders-table thead {
  background: rgba(0, 0, 0, 0.2);
}

.orders-table th {
  padding: 0.85rem 1rem;
  font-size: 0.75rem;
  color: rgba(226, 232, 240, 0.55);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  text-align: left;
}

.orders-table td {
  padding: 0.85rem 1rem;
  color: rgba(226, 232, 240, 0.85);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 0.9rem;
}

.orders-table tr.order-row {
  cursor: pointer;
  transition: background 0.15s;
}

.orders-table tr.order-row:hover {
  background: rgba(99, 102, 241, 0.08);
}

.text-right { text-align: right; }

.amount {
  font-weight: 600;
  color: #fbbf24;
}

.amount-sub {
  color: rgba(226, 232, 240, 0.7);
}

.created {
  font-size: 0.82rem;
  color: rgba(226, 232, 240, 0.6);
  white-space: nowrap;
}

.mono {
  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
  font-size: 0.85rem;
  color: rgba(226, 232, 240, 0.85);
}

.eshop-pill {
  display: inline-block;
  padding: 3px 10px;
  background: rgba(168, 85, 247, 0.2);
  color: #d8b4fe;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Status badge */
.sashe-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 12px;
  border: 1px solid;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
}

/* Empty state */
.loading-state, .empty-state {
  text-align: center;
  padding: 3rem 1rem;
  color: rgba(226, 232, 240, 0.5);
}

.empty-state svg {
  font-size: 3rem;
  color: rgba(255, 255, 255, 0.15);
  margin-bottom: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.empty-state p {
  font-size: 1.1rem;
  margin: 0.3rem 0;
}

.empty-state span {
  font-size: 0.9rem;
  color: rgba(226, 232, 240, 0.4);
}

/* Detail modal */
.order-modal-bg {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.order-modal-card {
  background: #1e293b;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  overflow: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.modal-header h2 {
  margin: 0;
  font-size: 1.3rem;
  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
  color: var(--text-primary, #f1f5f9);
}

.modal-header button {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(226, 232, 240, 0.7);
  width: 36px;
  height: 36px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-header button:hover {
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
}

.modal-body {
  padding: 1.5rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(226, 232, 240, 0.85);
  font-size: 0.95rem;
}

.detail-row > svg {
  color: rgba(99, 102, 241, 0.8);
  font-size: 0.9rem;
  flex-shrink: 0;
}

.detail-label {
  color: rgba(226, 232, 240, 0.55);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  min-width: 100px;
}

.detail-row a {
  color: #93c5fd;
  text-decoration: none;
}

.totals-box {
  margin-top: 0.5rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 1rem 1.2rem;
}

.totals-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  font-size: 0.95rem;
}

.totals-row strong {
  color: #fbbf24;
  font-size: 1.15rem;
}

.totals-row.sub {
  font-size: 0.85rem;
  color: rgba(226, 232, 240, 0.55);
}

.description-box {
  margin-top: 0.5rem;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  padding: 1rem 1.2rem;
}

.description-box h4 {
  margin: 0 0 0.6rem 0;
  font-size: 0.85rem;
  color: rgba(226, 232, 240, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.description-box pre {
  margin: 0;
  white-space: pre-wrap;
  font-family: inherit;
  font-size: 0.88rem;
  color: rgba(226, 232, 240, 0.85);
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/features/orders/SasheOrders.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,qFAAqF;EACrF,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc,0BAA0B,EAAE;AAC5C;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,uFAAuF;EACvF,sCAAsC;AACxC;;AAEA;EACE,sFAAsF;EACtF,sCAAsC;AACxC;;AAEA;EACE,sFAAsF;EACtF,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qFAAqF;EACrF,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,cAAc,iBAAiB,EAAE;;AAEjC;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uDAAuD;EACvD,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB","sourcesContent":[".sashe-orders-page {\n  padding: 1.5rem;\n  max-width: 1500px;\n  margin: 0 auto;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.sashe-orders-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sashe-orders-header h1 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.6rem;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.last-sync {\n  font-size: 0.8rem;\n  color: rgba(226, 232, 240, 0.5);\n}\n\n.btn-sync {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.7rem 1.3rem;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.4), rgba(139, 92, 246, 0.4));\n  border: 1px solid rgba(99, 102, 241, 0.4);\n  color: white;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.btn-sync:hover:not(:disabled) {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.55), rgba(139, 92, 246, 0.55));\n}\n\n.btn-sync:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Stats cards */\n.stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1.5fr;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n@media (max-width: 1024px) {\n  .stats-grid { grid-template-columns: 1fr; }\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n  border-radius: 14px;\n  padding: 1.25rem 1.4rem;\n  transition: all 0.2s;\n}\n\n.stat-card.week {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(99, 102, 241, 0.08));\n  border-color: rgba(99, 102, 241, 0.25);\n}\n\n.stat-card.month {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.12), rgba(34, 197, 94, 0.08));\n  border-color: rgba(16, 185, 129, 0.25);\n}\n\n.stat-card.status {\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.1), rgba(168, 85, 247, 0.06));\n  border-color: rgba(139, 92, 246, 0.25);\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  color: rgba(226, 232, 240, 0.55);\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.stat-main {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary, #f1f5f9);\n  margin-bottom: 10px;\n  line-height: 1;\n}\n\n.stat-sub {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 0.85rem;\n  color: rgba(226, 232, 240, 0.7);\n}\n\n.stat-sub strong {\n  color: #fbbf24;\n  font-weight: 600;\n}\n\n.status-mini-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.status-mini-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 0;\n  font-size: 0.85rem;\n}\n\n.status-mini-item .mini-label {\n  flex: 1;\n  color: rgba(226, 232, 240, 0.8);\n}\n\n.status-mini-item .mini-count {\n  font-weight: 600;\n  color: var(--text-primary, #f1f5f9);\n  background: rgba(255, 255, 255, 0.08);\n  padding: 1px 8px;\n  border-radius: 8px;\n  font-size: 0.8rem;\n}\n\n/* Filters */\n.filters-row {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 1rem 1.2rem;\n  margin-bottom: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.filter-group > label {\n  font-size: 0.8rem;\n  color: rgba(226, 232, 240, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  min-width: 60px;\n}\n\n.eshop-tabs {\n  display: flex;\n  gap: 4px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.eshop-tab {\n  background: transparent;\n  border: none;\n  color: rgba(226, 232, 240, 0.65);\n  padding: 6px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.15s;\n}\n\n.eshop-tab:hover {\n  color: var(--text-primary, #e2e8f0);\n}\n\n.eshop-tab.active {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.4), rgba(139, 92, 246, 0.4));\n  color: white;\n}\n\n.status-chips {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.status-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 10px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  color: rgba(226, 232, 240, 0.7);\n  transition: all 0.15s;\n}\n\n.status-chip:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.status-chip.clear {\n  background: rgba(239, 68, 68, 0.15);\n  color: #fca5a5;\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n/* Orders table */\n.orders-table-wrapper {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  overflow: hidden;\n  overflow-x: auto;\n}\n\n.orders-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 900px;\n}\n\n.orders-table thead {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.orders-table th {\n  padding: 0.85rem 1rem;\n  font-size: 0.75rem;\n  color: rgba(226, 232, 240, 0.55);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  text-align: left;\n}\n\n.orders-table td {\n  padding: 0.85rem 1rem;\n  color: rgba(226, 232, 240, 0.85);\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  font-size: 0.9rem;\n}\n\n.orders-table tr.order-row {\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.orders-table tr.order-row:hover {\n  background: rgba(99, 102, 241, 0.08);\n}\n\n.text-right { text-align: right; }\n\n.amount {\n  font-weight: 600;\n  color: #fbbf24;\n}\n\n.amount-sub {\n  color: rgba(226, 232, 240, 0.7);\n}\n\n.created {\n  font-size: 0.82rem;\n  color: rgba(226, 232, 240, 0.6);\n  white-space: nowrap;\n}\n\n.mono {\n  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;\n  font-size: 0.85rem;\n  color: rgba(226, 232, 240, 0.85);\n}\n\n.eshop-pill {\n  display: inline-block;\n  padding: 3px 10px;\n  background: rgba(168, 85, 247, 0.2);\n  color: #d8b4fe;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n/* Status badge */\n.sashe-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 12px;\n  border: 1px solid;\n  font-size: 0.78rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Empty state */\n.loading-state, .empty-state {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: rgba(226, 232, 240, 0.5);\n}\n\n.empty-state svg {\n  font-size: 3rem;\n  color: rgba(255, 255, 255, 0.15);\n  margin-bottom: 1rem;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.empty-state p {\n  font-size: 1.1rem;\n  margin: 0.3rem 0;\n}\n\n.empty-state span {\n  font-size: 0.9rem;\n  color: rgba(226, 232, 240, 0.4);\n}\n\n/* Detail modal */\n.order-modal-bg {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.order-modal-card {\n  background: #1e293b;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.75rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.3rem;\n  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;\n  color: var(--text-primary, #f1f5f9);\n}\n\n.modal-header button {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  color: rgba(226, 232, 240, 0.7);\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-header button:hover {\n  background: rgba(239, 68, 68, 0.15);\n  color: #fca5a5;\n}\n\n.modal-body {\n  padding: 1.5rem 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n}\n\n.detail-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: rgba(226, 232, 240, 0.85);\n  font-size: 0.95rem;\n}\n\n.detail-row > svg {\n  color: rgba(99, 102, 241, 0.8);\n  font-size: 0.9rem;\n  flex-shrink: 0;\n}\n\n.detail-label {\n  color: rgba(226, 232, 240, 0.55);\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  min-width: 100px;\n}\n\n.detail-row a {\n  color: #93c5fd;\n  text-decoration: none;\n}\n\n.totals-box {\n  margin-top: 0.5rem;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  padding: 1rem 1.2rem;\n}\n\n.totals-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 0;\n  font-size: 0.95rem;\n}\n\n.totals-row strong {\n  color: #fbbf24;\n  font-size: 1.15rem;\n}\n\n.totals-row.sub {\n  font-size: 0.85rem;\n  color: rgba(226, 232, 240, 0.55);\n}\n\n.description-box {\n  margin-top: 0.5rem;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 10px;\n  padding: 1rem 1.2rem;\n}\n\n.description-box h4 {\n  margin: 0 0 0.6rem 0;\n  font-size: 0.85rem;\n  color: rgba(226, 232, 240, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.description-box pre {\n  margin: 0;\n  white-space: pre-wrap;\n  font-family: inherit;\n  font-size: 0.88rem;\n  color: rgba(226, 232, 240, 0.85);\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
